<div class="container-fluid">
  <div class="page-head">
    <h5 class="header-title heading-color">Specialities<span class="float-right">
        <button type="submit" name="find" class="btn btn-primary text-white btn-rounded text-right"
          (click)="addSpeciality()">Add
          Specialities</button>
      </span>
    </h5>

  </div>
</div>

<div class="container-fluid" *ngIf="specialitiesList?.length>0">
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">NAME</th>
              </tr>
            </thead>
            <tr *ngFor="let s of specialitiesList">
              <td class="font-size-15">{{s?.id}}</td>
              <td class="font-size-15 text-color">{{s?.name}}</td>
            </tr>
          </table>

        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #SpecialityModal let-modal>
  <div class="modal-body p-4">
    <div class="row">
      <div class="col-lg-12">

        <form [formGroup]="specialitiesForm">
          <div class="row">
            <div class="col-lg-12">
              <input type="text" formControlName="name" class="form-control select" placeholder="Enter Specialities" />
            </div>
          </div>
          <br>
          <div class="row">
            <div class="btnwrap">
              <span>
                <button type="button" class="btn btn-model" (click)="modal.dismiss(false)"
                  style="background-color: #6f717d; color: white; margin-right: 10px;     margin-left: 15px;">
                  CANCEL</button>
              </span>
              <span>
                <button type="button" class="btn btn-primary btn-model" [disabled]="specialitiesForm.invalid"
                  (click)="addToDB()">Add Specialities</button>
              </span>
            </div>
          </div>

        </form>

      </div>
    </div>
  </div>
</ng-template>